var _g, _path, _g2, _path2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrants = function SvgGrants(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4420_237)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4420_237)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4420_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 55.4767C47.3961 55.1776 48.0797 55.1753 48.6562 55.4703L75.5213 69.2196C76.973 69.9626 76.973 72.0374 75.5213 72.7804L48.6562 86.5297C48.0797 86.8247 47.3961 86.8224 46.8216 86.5233L20.4081 72.774C18.9727 72.0269 18.9727 69.9731 20.4081 69.226L46.8216 55.4767Z",
    fill: "#967043",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4420_237",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 14.1547C47.4145 13.4402 48.9393 13.4402 50.1769 14.1547L77.3538 29.8453C78.5914 30.5598 79.3538 31.8803 79.3538 33.3094V64.6906C79.3538 66.1197 78.5914 67.4402 77.3538 68.1547L50.1769 83.8453C48.9393 84.5598 47.4145 84.5598 46.1769 83.8453L19.0008 68.1547C17.7633 67.4402 17.0009 66.1197 17.0008 64.6907L17.0001 33.3095C17 31.8804 17.7624 30.5598 19.0001 29.8453L46.1769 14.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4420_237)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2141 13)",
    fill: "url(#paint0_linear_4420_237)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6471 13.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2141 49)",
    fill: "url(#paint1_linear_4420_237)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2721 49.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0378 31)",
    fill: "url(#paint2_linear_4420_237)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0959 30.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6769 15.0207L76.8538 30.7113C77.782 31.2472 78.3538 32.2376 78.3538 33.3094V64.6906C78.3538 65.7624 77.782 66.7528 76.8538 67.2887L49.6769 82.9793C48.7487 83.5152 47.6051 83.5152 46.6769 82.9792L19.5008 67.2887C18.5727 66.7528 18.0009 65.7624 18.0008 64.6907L18.0001 33.3094C18 32.2376 18.5718 31.2472 19.5001 30.7113L46.6769 15.0207C47.6051 14.4848 48.7487 14.4848 49.6769 15.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4420_237)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4420_237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7605 53.233C61.4508 52.0374 62.3869 51.0492 63.3631 50.4856C64.3393 49.922 65.2754 49.8293 65.9657 50.2278C66.6559 50.6263 67.0437 51.4834 67.0437 52.6106C67.0437 53.1687 66.9485 53.7763 66.7635 54.3988C66.5786 55.0212 66.3075 55.6462 65.9657 56.2382C65.6239 56.8302 65.2182 57.3775 64.7716 57.8489C64.3251 58.3203 63.8464 58.7065 63.3631 58.9856C62.8798 59.2647 62.4011 59.4311 61.9546 59.4753C61.508 59.5195 61.1023 59.4407 60.7605 59.2434C60.4187 59.0461 60.1476 58.7341 59.9627 58.3252C59.7777 57.9164 59.6825 57.4187 59.6825 56.8606C59.6825 55.7334 60.0703 54.4285 60.7605 53.233ZM63.3631 51.4856C62.6166 51.9166 61.9007 52.6723 61.3729 53.5865C60.8451 54.5008 60.5485 55.4986 60.5485 56.3606C60.5485 56.7874 60.6213 57.168 60.7628 57.4806C60.9042 57.7933 61.1115 58.0318 61.3729 58.1827C61.6343 58.3336 61.9445 58.3939 62.286 58.3601C62.6275 58.3262 62.9935 58.199 63.3631 57.9856C63.7327 57.7722 64.0987 57.4768 64.4402 57.1163C64.7817 56.7559 65.092 56.3373 65.3533 55.8846C65.6147 55.432 65.822 54.954 65.9634 54.478C66.1049 54.002 66.1777 53.5374 66.1777 53.1106C66.1777 52.2486 65.8812 51.5932 65.3533 51.2884C64.8255 50.9837 64.1096 51.0546 63.3631 51.4856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3631 57.9856C63.6022 57.8475 63.7961 57.9595 63.7961 58.2356L63.7961 64.7981C63.7961 65.0742 63.6022 65.41 63.3631 65.5481C63.1239 65.6862 62.9301 65.5742 62.9301 65.2981L62.9301 58.7356C62.9301 58.4595 63.1239 58.1237 63.3631 57.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5835 62.9706C59.7119 62.6635 59.9795 62.4403 60.1813 62.4721C61.6232 62.6991 62.5135 63.2208 63.0476 63.6982C63.3144 63.9367 63.4914 64.1633 63.6036 64.3351C63.6596 64.421 63.6994 64.4931 63.7261 64.546C63.7394 64.5724 63.7495 64.5941 63.7566 64.6102L63.7652 64.6303L63.768 64.6371L63.769 64.6396L63.7694 64.6407L63.7696 64.6412C63.7697 64.6414 63.7698 64.6416 63.3767 65.0345L63.7698 64.6416C63.8519 64.8536 63.7364 65.2074 63.5118 65.4319C63.288 65.6556 63.0403 65.6665 62.9573 65.4568C62.9571 65.4564 62.9569 65.4559 62.9568 65.4554C62.9567 65.4553 62.9567 65.4552 62.9567 65.4552C62.9566 65.4551 62.9566 65.455 62.9566 65.455C62.9566 65.455 62.9566 65.455 62.9566 65.455L62.9567 65.4552L62.9567 65.4554L62.9568 65.4554L62.957 65.456L62.9573 65.4568L62.9573 65.4568L62.9545 65.4503C62.9513 65.4431 62.9455 65.4304 62.9366 65.4128C62.9189 65.3777 62.889 65.323 62.8439 65.2539C62.7538 65.1159 62.6028 64.9203 62.3663 64.7089C61.8939 64.2867 61.0771 63.7984 59.7163 63.5842C59.5146 63.5524 59.4551 63.2777 59.5835 62.9706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0899 60.9222C59.7713 60.5168 60.4455 60.3009 61.0581 60.2919C61.0776 60.2916 61.0965 60.2935 61.1144 60.2974C61.5334 60.3895 61.9644 60.6775 62.0543 61.2899C62.1493 61.936 61.8467 62.761 61.1721 63.6546C60.8628 64.5092 60.4147 65.1498 59.8813 65.4763C59.3536 65.7992 58.884 65.7233 58.5599 65.5034L58.5596 65.5031C58.1926 65.2531 58.003 64.8531 57.8384 64.5059C57.8215 64.4703 57.8048 64.4351 57.7883 64.4008C57.6073 64.0254 57.422 63.6938 57.0363 63.4849C56.9366 63.4309 56.8893 63.2982 56.9091 63.1282C56.9288 62.9581 57.0133 62.7712 57.1361 62.6257C57.7392 61.9112 58.4086 61.3277 59.0899 60.9222ZM60.6486 61.4106C60.1663 61.4242 59.6375 61.5965 59.1032 61.9144C58.7446 62.1278 58.3902 62.4028 58.0523 62.7287C58.2979 62.9763 58.451 63.2708 58.5823 63.5432C58.598 63.5758 58.6133 63.6077 58.6283 63.6391C58.8007 63.9996 58.9346 64.2793 59.1977 64.4586C59.4288 64.6154 59.6742 64.6026 59.8553 64.4917C59.9956 64.4059 60.2268 64.1801 60.4478 63.5098C60.4847 63.3977 60.5444 63.2874 60.6192 63.1932C61.1799 62.4863 61.2262 62.1252 61.1987 61.9384C61.1622 61.69 60.961 61.4876 60.6486 61.4106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1432 58.606C67.2716 58.7649 67.2121 59.1083 67.0103 59.373C65.6493 61.1587 64.8324 62.5902 64.3599 63.558C64.1234 64.0424 63.9723 64.4124 63.8822 64.6545C63.8372 64.7756 63.8073 64.8648 63.7896 64.9204C63.7807 64.9482 63.7749 64.9676 63.7717 64.9785L63.7689 64.9883C63.6859 65.2937 63.4382 65.5688 63.2144 65.6036C62.9898 65.6384 62.8743 65.418 62.9564 65.1113L63.3627 65.0482C62.9564 65.1113 62.9565 65.1109 62.9565 65.1106L62.9567 65.1099L62.9572 65.1084L62.9582 65.1046L62.9609 65.0947L62.9695 65.0647C62.9767 65.0402 62.9867 65.007 63.0001 64.9651C63.0268 64.8814 63.0666 64.7634 63.1226 64.6128C63.2348 64.3115 63.4119 63.8804 63.6787 63.3338C64.2128 62.2397 65.1033 60.6898 66.5455 58.7977C66.7472 58.5329 67.0149 58.4471 67.1432 58.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0776 58.2755C65.7654 58.7132 65.5644 59.1476 65.5279 59.4381C65.5005 59.6567 65.5468 59.9647 66.1078 60.0246C66.1824 60.0325 66.2421 60.0739 66.279 60.1434C66.4997 60.5586 66.7309 60.5173 66.8711 60.4412C67.0523 60.3428 67.2977 60.0723 67.5286 59.6487C67.7919 59.1654 67.9258 58.731 68.0983 58.1711C68.1132 58.1226 68.1285 58.0732 68.1441 58.0227C68.2754 57.5985 68.4286 57.127 68.6744 56.5955C68.3364 56.6599 67.9819 56.7941 67.6232 56.9949C67.0889 57.2939 66.56 57.7322 66.0776 58.2755ZM65.6682 57.6297C66.2808 56.9313 66.9551 56.3687 67.6365 55.9873C68.3179 55.606 68.9873 55.4166 69.5905 55.4345C69.7134 55.4382 69.7979 55.5275 69.8176 55.6748C69.8374 55.822 69.7901 56.0093 69.6904 56.1785C69.3045 56.8332 69.1191 57.3789 68.9382 57.9634C68.9217 58.0167 68.905 58.0709 68.8882 58.126C68.7235 58.6634 68.5338 59.2826 68.1665 59.9568L68.1664 59.9569C67.8425 60.5511 67.3729 61.1693 66.8452 61.4557C66.3117 61.7453 65.8636 61.622 65.5544 61.1243C64.88 61.0091 64.5775 60.5333 64.6723 59.7777C64.7622 59.0616 65.193 58.2761 65.6117 57.7004C65.6297 57.6757 65.6485 57.6521 65.6682 57.6297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0752 52.5268L64.175 51.8919C64.4142 51.7538 64.608 51.8657 64.608 52.1419C64.608 52.418 64.4142 52.7538 64.175 52.8919L63.0732 53.528C63.0051 53.5671 62.9389 53.6325 62.8863 53.7129C62.8336 53.7933 62.7977 53.8837 62.7848 53.9685C62.7719 54.0532 62.7827 54.1271 62.8154 54.1772C62.8481 54.2274 62.9007 54.2508 62.9641 54.2433L62.9649 54.2432L64.0816 54.1148C64.3313 54.0866 64.5389 54.1798 64.6677 54.3784C64.7964 54.577 64.8389 54.8687 64.7878 55.2034C64.7367 55.538 64.5953 55.8948 64.3877 56.2126C64.1802 56.5303 63.9195 56.7892 63.6503 56.9448L62.5512 57.5794C62.3121 57.7174 62.1182 57.6055 62.1182 57.3294C62.1182 57.0532 62.3121 56.7174 62.5512 56.5794L63.6497 55.9452C63.6497 55.9451 63.6496 55.9452 63.6497 55.9452C63.7177 55.9058 63.7838 55.8402 63.8363 55.7599C63.8888 55.6795 63.9246 55.5892 63.9375 55.5045C63.9504 55.4198 63.9397 55.346 63.9071 55.2958C63.8746 55.2456 63.8223 55.222 63.7592 55.229C63.7591 55.229 63.7593 55.229 63.7592 55.229L62.6439 55.3573C62.6438 55.3573 62.6441 55.3573 62.6439 55.3573C62.3934 55.3867 62.1851 55.2943 62.0557 55.0958C61.9262 54.8973 61.8833 54.6051 61.9345 54.2696C61.9857 53.9342 62.1278 53.5765 62.3361 53.2582C62.5443 52.9403 62.8057 52.6817 63.0752 52.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3631 51.8918C63.6022 51.7538 63.7961 51.8657 63.7961 52.1418L63.7961 52.6106C63.7961 52.8867 63.6022 53.2225 63.3631 53.3606C63.1239 53.4987 62.9301 53.3867 62.9301 53.1106L62.9301 52.6418C62.9301 52.3657 63.1239 52.0299 63.3631 51.8918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3631 56.1106C63.6022 55.9725 63.7961 56.0845 63.7961 56.3606L63.7961 56.8293C63.7961 57.1055 63.6022 57.4413 63.3631 57.5793C63.1239 57.7174 62.9301 57.6055 62.9301 57.3293L62.9301 56.8606C62.9301 56.5845 63.1239 56.2487 63.3631 56.1106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3632 51.4856C62.6167 51.9166 61.9008 52.6723 61.373 53.5865C60.8451 54.5008 60.5486 55.4986 60.5486 56.3606C60.5486 56.7874 60.6214 57.168 60.7628 57.4806C60.9043 57.7933 61.1116 58.0318 61.373 58.1827C61.6343 58.3336 61.9446 58.3939 62.2861 58.3601C62.6276 58.3262 62.9936 58.199 63.3632 57.9856C63.7328 57.7722 64.0988 57.4768 64.4403 57.1163C64.7817 56.7559 65.092 56.3373 65.3534 55.8846C65.6147 55.432 65.8221 54.954 65.9635 54.478C66.1049 54.002 66.1777 53.5374 66.1777 53.1106C66.1777 52.2486 65.8812 51.5932 65.3534 51.2884C64.8255 50.9837 64.1096 51.0546 63.3632 51.4856Z",
    fill: "url(#paint3_linear_4420_237)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7605 53.233C61.4508 52.0374 62.3869 51.0492 63.3631 50.4856C64.3393 49.922 65.2754 49.8293 65.9657 50.2278C66.6559 50.6263 67.0437 51.4834 67.0437 52.6106C67.0437 53.1687 66.9485 53.7763 66.7635 54.3988C66.5786 55.0212 66.3075 55.6462 65.9657 56.2382C65.6239 56.8302 65.2182 57.3775 64.7716 57.8489C64.3251 58.3203 63.8464 58.7065 63.3631 58.9856C62.8798 59.2647 62.4011 59.4311 61.9546 59.4753C61.508 59.5195 61.1023 59.4407 60.7605 59.2434C60.4187 59.0461 60.1476 58.7341 59.9627 58.3252C59.7777 57.9164 59.6825 57.4187 59.6825 56.8606C59.6825 55.7334 60.0703 54.4285 60.7605 53.233ZM63.3631 51.4856C62.6166 51.9166 61.9007 52.6723 61.3729 53.5865C60.8451 54.5008 60.5485 55.4986 60.5485 56.3606C60.5485 56.7874 60.6213 57.168 60.7628 57.4806C60.9042 57.7933 61.1115 58.0318 61.3729 58.1827C61.6343 58.3336 61.9445 58.3939 62.286 58.3601C62.6275 58.3262 62.9935 58.199 63.3631 57.9856C63.7327 57.7722 64.0987 57.4768 64.4402 57.1163C64.7817 56.7559 65.092 56.3373 65.3533 55.8846C65.6147 55.432 65.822 54.954 65.9634 54.478C66.1049 54.002 66.1777 53.5374 66.1777 53.1106C66.1777 52.2486 65.8812 51.5932 65.3533 51.2884C64.8255 50.9837 64.1096 51.0546 63.3631 51.4856Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4420_237",
    x: 3.33154,
    y: 39.2507,
    width: 89.2786,
    height: 63.4987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.439216 0 0 0 0 0.262745 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4420_237"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4420_237",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4420_237",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4420_237",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4420_237",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4420_237",
    x1: 66.1777,
    y1: 56.3588,
    x2: 60.4012,
    y2: 53.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4420_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4420_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4420_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 53 52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4420_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 56.4641 54)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrants);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grants.a4e93eeb46f8b4612f0e759c07603688.svg";